import { Outlet, useLocation } from 'react-router-dom'
import { useContext, useEffect, useState, useRef } from 'react'
import ClientContext from 'contexts/ClientContext'
import api from 'helpers/api'

const Contacts = () => {
  const { state } = useLocation()
  const clientContext = useContext(ClientContext)
  const { isColabelAllowed, contractTypeId } = clientContext
  const [client, setClient] = useState(state?.client || clientContext || null)
  const fetched = useRef(null)

  useEffect(() => {
    const getClient = async () => {
      try {
        if (isColabelAllowed && !contractTypeId) return
        fetched.current = contractTypeId
        const clientRes = isColabelAllowed
          ? await api.get({ url: '/clients/me/'+contractTypeId })
          : await api.get({ url: '/clients/me' })
        setClient({...client, ...clientRes.client})
      } catch (error) {
        console.log('Fetch client contacts error')
      }
    }

    if (!client?.firstname || fetched.current !== contractTypeId) getClient()
    if (state?.client) {
      setClient(state?.client)
    }
  }, [client, state?.client, isColabelAllowed, contractTypeId, fetched])

  return (
    <div>
      <Outlet context={client} />
    </div>
  )
}

export default Contacts
